import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "./ui/hover-card";
import { Info } from "lucide-react";
import { FeesPaymentDialogProps } from "src/interfaces/functionalComponentInterface";

const FeesPaymentDialog: React.FC<FeesPaymentDialogProps> = ({
  isOpen,
  setIsOpen,
  totalClients,
  totalAccountValue,
  numberOfWeeks,
  detailData,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button className="btn-inset-shadow text-primary border border-primary w-full bg-transparent hover:text-primary text-xs md:text-sm font-medium hover:bg-[#F6F6F6] transition-all duration-400 ease-in-out group">
          Details
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="stroke-primary group-hover:stroke-white transition-all duration-400 ease-in-out"
          >
            <path
              d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11 15V11"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11 7H11.01"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-[90vw] md:max-w-lg w-full p-4 md:p-6 rounded-xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base md:text-lg font-title">
            Fees and Payment Details
            <HoverCard>
              <HoverCardTrigger>
                <Info className="w-5 h-5 text-gray-600 hover:text-gray-800 cursor-pointer" />
              </HoverCardTrigger>
              <HoverCardContent className="text-sm text-gray-600 p-4 rounded-md shadow-lg bg-white font-sans">
                <p>
                  Payments are calculated based on the cumulative account value,
                  a charging fee percentage, and a paid percentage for previous
                  payments month.
                </p>
                <ul className="list-disc pl-6 mt-2">
                  <li>Charging Fee: 1.45%</li>
                  <li>Paid Percentage: 1 / 1.45</li>
                  <li>Calculated Monthly</li>
                </ul>
              </HoverCardContent>
            </HoverCard>
          </DialogTitle>
        </DialogHeader>
        <div className="mt-4 space-y-4">
          <div>
            <p className="text-sm text-gray-600 mb-2">
              Here's a detailed breakdown of your fees and payment details:
            </p>
            <ul className="list-disc pl-6 space-y-1 text-sm">
              <li>Total Households: {totalClients}</li>
              <li>
                Total Account Value: ${totalAccountValue.toLocaleString()}
              </li>
              <li>Weeks Planned: {numberOfWeeks}</li>
            </ul>
          </div>
          <div>
            <h3 className="text-base font-semibold text-gray-800 mb-2">
              Payment Breakdown:
            </h3>
            <ul className="space-y-1 text-sm">
              {Object.entries(detailData).map(
                ([key, { month, paymentAmount, bonus }]) => (
                  <li key={key} className="flex justify-between">
                    <span className="font-medium">{month}:</span>
                    <span>
                      ${paymentAmount.toLocaleString()} + $
                      {bonus.toLocaleString()} (Bonus)
                    </span>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FeesPaymentDialog;
